import React, { useState } from "react";
import Logo from "./asserts/images/full-logo.png";
import Footer from "./asserts/images/footer.png";
import BannerLogo from "./asserts/images/banner-logo.png";
import FoundLogo from "./asserts/images/found.png";
import EvolvingLogo from "./asserts/images/evolving.png";
import PowerLogo from "./asserts/images/power.png";
import AboutImg from "./asserts/images/about-img.png";
import ExpertImg from "./asserts/images/expert.png";
import CommunityImg from "./asserts/images/community.png";
import learnImg from "./asserts/images/learn.png";
import platformImg from "./asserts/images/platform.png";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa6";
import { IoMailSharp } from "react-icons/io5";
import { collection, addDoc } from "firebase/firestore";
import { db } from "./firebase";
import { PlanContainer } from "./components/plan";
import { Input, PhoneInput } from "./components/fields";
import { Button } from "./components/button";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { addSubscribe } from "./api/subscribe";
import Flag from "./asserts/images/flag.png";
import { Link } from "react-router-dom";
import Play from "./asserts/images/play-store.svg";
import { MdPolicy, MdPrivacyTip } from "react-icons/md";

let container = "max-w-screen-2xl m-auto p-6";
let title = "text-6xl font-black py-10";
let sub_title = "text-4xl";

export const LanunchingPage = () => {
  const [data, setData] = useState({
    name: "",
    phone: "",
    email: "",
    country_code: "+91",
  });
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    data[name] = value;
    setData({ ...data });
  };

  const addTodo = async (e) => {
    setSuccess(true);
    try {
      await addDoc(collection(db, "Users"), {
        user: data,
      });
      addSubscribe({ ...data })
        .then(({ message }) => { })
        .catch((err) => {
          console.log(err);
        });
      setTimeout(() => {
        setData({
          name: "",
          phone: "",
          email: "",
          country_code: "+91",
        });
        setSuccess(false);
      }, 3000);
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  };

  return (
    <main>
      <section className="fixed bg-black w-full z-50">
        <p className="text-2xl text-white text-center p-2 flex items-center justify-center gap-3 flex-warp">
          <img src={Flag} alt="flag" width={30} />
          <span>Parents who are based in India get additional 50% off</span>
        </p>
      </section>
      <section className="banner">
        <div className={container}>
          <div className="w-full flex justify-end">
            <div className="max-w-52 mt-10">
              <img src={Logo} alt="Logo" />
            </div>
          </div>
          <div className="flex justify-between py-20 items-center">
            <div>
              <h2
                className={`${title} text-white font-medium banner-title`}
                style={{ lineHeight: "94px", fontSize: "4rem" }}
              >
                iOS App Launching on May 10th!
                <br className="break-tag"></br> Global Release on May 15th!
                Android Release Now Available for Parents Based in India on
                Playstore
              </h2>
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=app.awetism.insights&pli=1"
                  target="_blank"
                  alt=""
                  rel="noreferrer"
                >
                  <img src={Play} alt="img" style={{ height: "68px" }} />
                </a>
              </div>
            </div>
            <div className="max-w-md logo">
              <img src={BannerLogo} alt="img" />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div
          className={`${container} flex justify-center items-center pt-20 xs:flex-wrap`}
        >
          <p className="text-4xl pb-2 main-text" style={{ lineHeight: "50px" }}>
            <span className="font-semibold text-[#A7C836]">
              Awetism Insights
            </span>{" "}
            is a #1 Membership for getting Occupational therapy support and
            insights for your child who has a diagnosis of Autism. (18 months to
            18 years)
          </p>
        </div>
      </section>
      <section className="flex justify-center">
        <div className="max-w-3xl">
          <img src={AboutImg} alt="Logo" />
        </div>
      </section>

      <section>
        <div
          className={`${container} flex justify-center items-center xs:flex-wrap`}
        >
          <p className="text-2xl pb-6 main-text" style={{ lineHeight: "40px" }}>
            Get <span className="font-semibold text-[#A7C836]">Reena's</span>{" "}
            23+ years of expertise through daily insights, deep-dive bi-monthly
            live sessions, and a treasure trove of resources—all without the
            hassle of separate fees or waitlists. Plus, become part of a vibrant
            community of parents sharing your journey, offering mutual support
            and shared solutions.
          </p>
        </div>
      </section>
      <section className="banner">
        <div className={`${container}`}>
          <h1 className="text-white text-center text-3xl font-medium py-8">
            Here is what you get
          </h1>
          <Swiper
            modules={[Autoplay]}
            spaceBetween={120}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              400: {
                slidesPerView: 1,
              },
              639: {
                slidesPerView: 1,
              },
              865: {
                slidesPerView: 2,
              },
              1000: {
                slidesPerView: 2,
              },
              1300: {
                slidesPerView: 3,
              },
              1700: {
                slidesPerView: 3,
              },
            }}
            navigation
          >
            <SwiperSlide>
              <div
                className="p-10 my-10 rounded-lg custom-slide"
                style={{
                  width: "380px",
                  border: "2px solid #D3EAC8",
                  height: "20rem",
                }}
              >
                <div className="">
                  <div className="max-w-20">
                    <img src={ExpertImg} alt="icon" />
                  </div>
                </div>
                <div className="text-2xl font-medium py-4 text-white">
                  Immediate Expert Access
                </div>
                <div className="text-xl text-white">
                  Say goodbye to waiting lists and hello to immediate support.
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div
                className="p-10 my-10 rounded-lg custom-slide"
                style={{
                  width: "380px",
                  border: "2px solid #D3EAC8",
                  height: "20rem",
                }}
              >
                <div className="">
                  <div className="max-w-20">
                    <img src={platformImg} alt="icon" />
                  </div>
                </div>
                <div className="text-2xl font-medium py-4 text-white">
                  All-In-One Platform
                </div>
                <div className="text-xl text-white">
                  Enjoy masterclasses, courses, and community support, all
                  bundled into one seamless membership.
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div
                className="p-10 my-10 rounded-lg custom-slide"
                style={{
                  width: "380px",
                  border: "2px solid #D3EAC8",
                  height: "20rem",
                }}
              >
                <div className="">
                  <div className="max-w-20">
                    <img src={learnImg} alt="icon" />
                  </div>
                </div>
                <div className="text-2xl font-medium py-4 text-white">
                  Consistent Learning
                </div>
                <div className="text-xl text-white">
                  Stay engaged with daily insights which helps you to build
                  consistency and momentum.
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div
                className="p-10 my-10 rounded-lg custom-slide"
                style={{
                  width: "380px",
                  border: "2px solid #D3EAC8",
                  height: "20rem",
                }}
              >
                <div className="">
                  <div className="max-w-20">
                    <img src={CommunityImg} alt="icon" />
                  </div>
                </div>
                <div className="text-2xl font-medium py-4 text-white">
                  Empowering Community
                </div>
                <div className="text-xl text-white">
                  You're not alone. Our supportive network of parents and
                  experts will make your journey smoother.
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div
                className="p-10 my-10 rounded-lg custom-slide"
                style={{
                  width: "380px",
                  border: "2px solid #D3EAC8",
                  height: "20rem",
                }}
              >
                <div className="text-xl text-white">
                  Transformation of you as a parent and in your child as you
                  leverage a holistic approach perfected over 23 years, blending
                  expert advice, community support, and continuous learning for
                  the ultimate care strategy.
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <h1 className="text-4xl text-center py-4 text-white">
            Join us now and take the first step to navigate your journey with
            clarity and calmness.
          </h1>
        </div>
      </section>
      <section>
        <div className={container}>
          <div className={"text-3xl pt-16 w-full text-center"}>
            Plans to choose from
          </div>
        </div>
        <div>
          <PlanContainer
            title="Foundation Level"
            img={FoundLogo}
            monthAmount="1,800"
            yearAmount="12,000"
            amount="46,800"
            left_count={3}
            right_count={3}
            sub_title={
              "Free trial of 14 days then billed annually, Cancel anytime !"
            }
            des={[
              {
                label: "2 Audio books (INR 1,800)",
                value: [
                  "looking beyond labels... Becoming a Mindful Parent!!",
                  "Little Parenting Guru",
                ],
              },
              {
                label:
                  "Daily insights from Reena Singh - Get 23 years of wisdom every single day to help you navigate the journey of supporting your child with calmness and complete clarity. (INR 15,000)",
              },
              { label: "Youtube live sessions (INR 12,000)" },
              {
                label:
                  "Meet once a month on Friday to discuss monthly time management (INR 18,000)",
              },
              {
                label:
                  "UNLIMITED USE of our tracking system to track your day, week and month. This helps you to understand what worked and what did not so that you can support your child with mindfulness.",
              },
            ]}
          />
        </div>
        <div style={{ background: "#F9FFE2" }}>
          <PlanContainer
            title="Evolving Level"
            img={EvolvingLogo}
            amount="2,59,800"
            res={true}
            monthAmount="8,000"
            yearAmount="80,000"
            left_count={2}
            right_count={2}
            des={[
              {
                label:
                  "13 masterclasses which are charged separately (total 1,08,000) earlier but you get complete access to all now in the app",
                value: [
                  "What is Autism",
                  "Oral motor challenges",
                  "Sensory diet",
                  "Using visual supports",
                  "Supporting sleep",
                  "Teaching toilet and potty training to your child",
                  "Emotional wellness 2021",
                  "Emotional wellness 2022",
                  "Emotional wellness 2023",
                  "Masterclass on making academics fun",
                  "Masterclass on PECS",
                  "Masterclass on auditory processing",
                  "Masterclass on tactile processing",
                ],
              },
              { label: "Youtube live -question and answer session" },
              {
                label:
                  "Get access to 78 techniques that you can use with your child. Get demonstration videos with explanation on each technique. (INR 75,000)",
              },
              {
                label:
                  "Meet once a month for an hour for therapy related topic (INR 24,000)",
              },
              {
                label:
                  "Meet twice a month on Friday to discuss the weekly and monthly time management (INR 36,000)",
              },
              {
                label: "2 Audio books (INR 1,800)",
                value: [
                  "looking beyond labels... Becoming a Mindful Parent!!",
                  "Little Parenting Guru",
                ],
              },
              {
                label:
                  "Daily insights from Reena Singh - Get 23 years of wisdom every single day to help you navigate the journey of supporting your child with calmness and complete clarity. (INR 15,000)",
              },
              {
                label:
                  "UNLIMITED USE of our tracking system to track your day, week and month. This helps you to understand what worked and what did not so that you can support your child with mindfulness.",
              },
            ]}
          />
        </div>
        <div>
          <PlanContainer
            title="Empowered Level"
            img={PowerLogo}
            amount="4,90,800"
            res={true}
            monthAmount="16,000"
            yearAmount="1,60,000"
            left_count={4}
            right_count={4}
            des={[
              {
                label: "Immediate access to 5 recorded course (INR 1,21,000)",
                value: [
                  "Autism intervention program",
                  "Primitive reflex integration for emotional regulation",
                  "Boost oral motor fine motor skills program",
                  "Laying the foundation for learning",
                  "Managing behaviours",
                  "Primitive reflex integration for academic readiness",
                ],
              },
              {
                label:
                  "Get access to more than 100 techniques that you can use with your child. Get demonstration videos with explanation on each technique. (INR 1,25,000)",
              },
              {
                label:
                  "Meet twice a month for discussion on therapy related topic for an hour (INR 48,000)",
              },
              {
                label:
                  "Meet every Friday to discuss the weekly and monthly time management (INR 72,000)",
              },
              {
                label:
                  "13 masterclasses which are charged separately (total 1,08,000) earlier but you get complete access to all now in the app",
                value: [
                  "What is Autism",
                  "Oral motor challenges",
                  "Sensory diet",
                  "Using visual supports",
                  "Supporting sleep",
                  "Teaching toilet and potty training to your child",
                  "Emotional wellness 2021",
                  "Emotional wellness 2022",
                  "Emotional wellness 2023",
                  "Masterclass on making academics fun",
                  "Masterclass on PECS",
                  "Masterclass on auditory processing",
                  "Masterclass on tactile processing",
                ],
              },
              { label: "Youtube live -question and answer session" },
              {
                label: "2 Audio books (INR 1,800)",
                value: [
                  "looking beyond labels... Becoming a Mindful Parent!!",
                  "Little Parenting Guru",
                ],
              },
              {
                label:
                  "Daily insights from Reena Singh - Get 23 years of wisdom every single day to help you navigate the journey of supporting your child with calmness and complete clarity. (INR 15,000)",
              },
            ]}
          />
        </div>
      </section>

      <section className="m-8">
        <div className={`${container} banner rounded-3xl p-16 relative`}>
          <div className="flex justify-center items-center gap-10">
            <div className="max-w-md w-[50%] logo">
              <img src={Footer} alt="img" />
            </div>
            <div className="w-[50%] reg-form">
              <div className="w-full text-center pb-10">
                <h3 className="text-3xl text-white">
                  Pre-subscribe Today and Enjoy 1st Month of Foundation Level
                  absolutely Free
                </h3>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  addTodo(e);
                }}
              >
                <Input
                  label="Name"
                  onChange={handleChange}
                  name={"name"}
                  value={data.name}
                />
                <Input
                  onChange={handleChange}
                  name={"email"}
                  value={data.email}
                  label="Email"
                />
                <PhoneInput
                  label="Phone Number"
                  name={"phone"}
                  code={data.country_code}
                  onChange={handleChange}
                  value={data.phone}
                />
                {success && (
                  <p className="text-2xl text-white text-center pb-4">
                    Registered successfully...!
                  </p>
                )}
                <div className="text-center">
                  <Button disable={success} label={"Pre-Subscribe"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section style={{ background: "#000" }} className="mt-20">
        <div className={`${container} py-36`}>
          <div className="flex justify-between flex-wrap">
            <a href="/">
              <div className="max-w-52 py-8">
                <img src={Logo} alt="Logo" />
              </div>
            </a>
            <div className="py-8" style={{ color: "#fff" }}>
              <h1 className="text-xl font-medium">Contact us</h1>
              <div className="text-xl pt-4 flex gap-2 items-center">
                <IoMailSharp />
                <a href="mailto:info@awetisminsights.com">
                  info@awetisminsights.com
                </a>
              </div>
            </div>
            <div className="py-8" style={{ color: "#fff" }}>
              <h1 className="text-xl font-medium">Policy</h1>
              <div className="flex flex-col">
                <div className="text-xl pt-4 flex gap-2 items-center">
                  <IoMailSharp />
                  <Link to={"/terms"}>
                    Terms & Conditions
                  </Link>
                </div>
                <div className="text-xl pt-4 flex gap-2 items-center">
                  <MdPrivacyTip />
                  <Link to={"/privacy"}>
                    Privacy Policy
                  </Link>
                </div>
                <div className="text-xl pt-4 flex gap-2 items-center">
                  <MdPolicy />
                  <Link to={"/cookie"}>
                    Cookie Policy
                  </Link>
                </div>
              </div>
            </div>
            <div className="py-8" style={{ color: "#fff" }}>
              <h1 className="text-xl font-medium">Get in Touch</h1>
              <div className="flex gap-8 pt-4 flex-wrap">
                <a
                  href="https://www.facebook.com/awetisminsights"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF className="social-icon" />
                </a>
                <a
                  href="https://www.instagram.com/awetisminsights"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaInstagram className="social-icon" />
                </a>
                <a
                  href="https://www.youtube.com/@awetisminsights"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaYoutube className="social-icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
